import React from "react";

export function navigate(href: string) {
  if (href.startsWith("http://") || href.startsWith("https://") || href.startsWith("//")) {
    window.location.href = href;
    return;
  }
  if (window.location.pathname === href) return;
  window.history.pushState(null, "", href);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  prefetch?: boolean;
  replace?: boolean;
  scroll?: boolean;
};

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ href, children, onClick, target, ...props }, ref) => {
    const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
      if (onClick) onClick(e);
      if (e.defaultPrevented) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (e.button !== 0) return;
      if (target && target !== "_self") return;
      if (href.startsWith("http://") || href.startsWith("https://") || href.startsWith("//")) return;
      e.preventDefault();
      navigate(href);
    };

    return (
      <a ref={ref} href={href} target={target} onClick={handleClick} {...props}>
        {children}
      </a>
    );
  }
);

Link.displayName = "Link";

export default Link;
